<div class="nameAddress">
  @if (personalName) {
  <div [formGroup]="personalName">
    <div class="row g-3">
      <div class="col-sm-8 col-lg-3 col-md-3">
        <nh-field
          [attr.aria-required]="nameMandatory"
          id="{{ addressname + '_firstName' }}"
          [isRow]="true"
          [mandatory]="nameMandatory"
          label="{{ 'FIRST_NAME' | globalTranslate }}"
        >
          @if (isDisplayPopUp()) {
          <nh-popover
            class="ps-1"
            content="{{ 'NAME_POPUP' | globalTranslate }}"
          ></nh-popover>
          }
          <input
            type="text"
            [attr.aria-label]="'FIRST_NAME' | globalTranslate"
            name="firstName"
            formControlName="firstName"
            class="form-control"
            [required]="nameMandatory"
            [attr.disabled]="
              (isRmbRmc && namePopup) || isExported ? true : null
            "
            maxlength="45"
          />
        </nh-field>
      </div>
      <div class="col-sm-4 col-lg-4 col-md-4">
        <nh-field
          [attr.aria-required]="false"
          id="{{ addressname + '_middleInitial' }}"
          [isRow]="true"
          [mandatory]="false"
          label="{{ 'MIDDLE_NAME' | globalTranslate }}"
        >
          @if (isDisplayPopUp()) {
          <nh-popover
            class="ps-1"
            content="{{ 'NAME_POPUP' | globalTranslate }}"
          ></nh-popover>
          }
          <input
            [attr.aria-label]="'MIDDLE_NAME' | globalTranslate"
            type="text"
            name="middleInitial"
            formControlName="middleInitial"
            class="form-control"
            mask="S"
            [attr.disabled]="
              (isRmbRmc && namePopup) || isExported ? true : null
            "
          />
        </nh-field>
      </div>
      <div class="col-sm-8 col-lg-3 col-md-3">
        <nh-field
          [attr.aria-required]="nameMandatory"
          id="{{ addressname + '_lastName' }}"
          [isRow]="true"
          [mandatory]="nameMandatory"
          label="{{ 'LAST_NAME' | globalTranslate }}"
        >
          @if (isDisplayPopUp()) {
          <nh-popover
            class="ps-1"
            content="{{ 'NAME_POPUP' | globalTranslate }}"
          ></nh-popover>
          }
          <input
            [attr.aria-label]="'LAST_NAME' | globalTranslate"
            type="text"
            name="lastName"
            formControlName="lastName"
            class="form-control"
            [required]="nameMandatory"
            [attr.disabled]="
              (isRmbRmc && namePopup) || isExported ? true : null
            "
            maxlength="45"
          />
        </nh-field>
      </div>
      <div class="col-sm-4 col-lg-2 col-md-2">
        <nh-field
          [attr.aria-required]="false"
          id="{{ addressname + '_suffix' }}"
          [isRow]="true"
          [mandatory]="false"
          label="{{ 'SUFFIX' | globalTranslate }}"
        >
          @if (isDisplayPopUp()) {
          <nh-popover
            class="ps-1"
            content="{{ 'NAME_POPUP' | globalTranslate }}"
          ></nh-popover>
          }
          <select
            [attr.aria-label]="'SUFFIX' | globalTranslate"
            nh
            name="suffix"
            [items]="tableSuffix"
            formControlName="suffix"
            [attr.disabled]="
              (isRmbRmc && namePopup) || isExported ? true : null
            "
          ></select>
        </nh-field>
      </div>
    </div>
  </div>
  } @if (address) {
  <div [formGroup]="address">
    <div class="row g-3">
      <div class="col-md-8">
        <nh-field
          [attr.aria-required]="addressFieldMandatory"
          id="{{ addressname + '_addressLine1' }}"
          [isRow]="true"
          [mandatory]="addressFieldMandatory"
          label="{{ (appType === 'MEDICAL_APPEAL' ? 'MA_ADDRESS_LINE_1' : 'ADDRESS_LINE_1') | globalTranslate }}"
        >
          @if (addressLine1ToolTip) {
          <nh-popover
            class="ps-1"
            content="{{ 'ADDRESS_LINE1_POPUP' | globalTranslate }}"
          ></nh-popover>
          }
          <input
            type="text"
            name="addressLine1"
            [attr.aria-label]="(appType === 'MEDICAL_APPEAL' ? 'MA_ADDRESS_LINE_1' : 'ADDRESS_LINE_1') | globalTranslate"
            formControlName="addressLine1"
            class="form-control"
            maxlength="{{ maxLengthAddressLine1 }}"
            placeholder="105 Johnson Street"
            [attr.disabled]="isDisabled ? true : null"
            [required]="addressFieldMandatory"
          />
        </nh-field>
      </div>
      <div class="col-md-8">
        <nh-field
          [attr.aria-required]="false"
          id="{{ addressname + '_addressLine2' }}"
          [isRow]="true"
          [mandatory]="false"
          label="{{ (appType === 'MEDICAL_APPEAL' ? 'MA_ADDRESS_LINE_2' : 'ADDRESS_LINE_2') | globalTranslate }}"
        >
          @if (addressLine2ToolTip) {
          <nh-popover
            class="ps-1"
            content="{{ 'ADDRESS_LINE2_POPUP' | globalTranslate }}"
          ></nh-popover>
          }
          <input
            type="text"
            class="form-control"
            name="addressLine2"
            [attr.aria-label]="(appType === 'MEDICAL_APPEAL' ? 'MA_ADDRESS_LINE_2' : 'ADDRESS_LINE_2') | globalTranslate"
            formControlName="addressLine2"
            maxlength="{{ maxLengthAddressLine2 }}"
            placeholder="Apt 305"
            [attr.disabled]="isDisabled ? true : null"
          />
        </nh-field>
      </div>
      <div class="col-md-12">
        <nh-city-state
          [addressname]="addressname"
          [isAssistingPerson]="isAssistingPerson"
          [stateDefault]="stateDefault"
          [format]="addressFormat"
          [addressFieldMandatory]="addressFieldMandatory"
          [address]="address"
          [tables]="tables"
          [isDisabled]="isDisabled"
          [hideCounty]="hideCounty"
          [separateZipFields]="separateZipFields"
          [cityMaxLength]="cityMaxLength"
          [sectionId]="sectionId"
        ></nh-city-state>
      </div>
    </div>
  </div>
  }
</div>